import ReactDOM from "react-dom/client";
import App from "./App";
import setupOpenApi from "./api/config";
import "./index.css";
import { getAuthenticationManager } from "./utils/Authentication";

getAuthenticationManager().bootstrap(() => {
    const root = ReactDOM.createRoot(
        document.getElementById("root") as HTMLElement
    );

    setupOpenApi();

    root.render(<App />);
});
